module.exports = __webpack_public_path__ + "img/pick2.d0a403bf.png";